let gallerySlideshowSwiper = new Swiper('.gallery-display-as-slideshow .swiper', {
	slidesPerView: 'auto',
	spaceBetween:  16,
	speed:         500,
	autoHeight:    true,
	pagination:    {
		el:        ".swiper-pagination",
		clickable: true
	},
	/*loop:          true,
	autoplay:      {
		delay:                3000,
		stopOnLastSlide:      false
	},*/
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
});


let moduleSlideshowSwiper = new Swiper('.module-slideshow .swiper', {
	slidesPerView: 1,
	loop:          false,
	navigation:    {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination:    {
		el:           '.swiper-pagination',
		type:         'custom',
		renderCustom: function (swiper, current, total) {
			return '<span class="swiper-pagination-current">' + current.toString().padStart(2, '0') + '</span> <span class="swiper-pagination-separator"></span> <span class="swiper-pagination-total">' + total.toString().padStart(2, '0') + '</span>';
		}
	},
});



let moduleSlideshowConSfondoSwiper = new Swiper('.module-slideshow-con-sfondo .swiper', {
	slidesPerView: 1,
	spaceBetween:  0,
	effect:        'fade',
	pagination:    {
		el:           '.swiper-pagination',
		type:         'custom',
		renderCustom: function (swiper, current, total) {
			return '<span class="swiper-pagination-current">' + current.toString().padStart(2, '0') + '</span> <span class="swiper-pagination-separator"></span> <span class="swiper-pagination-total">' + total.toString().padStart(2, '0') + '</span>';
		}
	},
	loop:          false,
	navigation:    {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	grabCursor:     true
});

let moduleSlideshowDoppioMainSwiper = new Swiper('.module-slideshow-doppio .swiper--main', {
	slidesPerView:     1,
	loop:              false,
});


let moduleSlideshowDoppioNavSwiper = new Swiper('.module-slideshow-doppio .swiper--nav', {
	slidesPerView: 1,
	loop:          false,
	navigation:    {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination:    {
		el:           '.swiper-pagination',
		type:         'custom',
		renderCustom: function (swiper, current, total) {
			return '<span class="swiper-pagination-current">' + current.toString().padStart(2, '0') + '</span> <span class="swiper-pagination-separator"></span> <span class="swiper-pagination-total">' + total.toString().padStart(2, '0') + '</span>';
		}
	},
});

moduleSlideshowDoppioNavSwiper.controller.control = moduleSlideshowDoppioMainSwiper;
moduleSlideshowDoppioMainSwiper.controller.control = moduleSlideshowDoppioNavSwiper;
